import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../images/20220820_194915.jpg'


const _hoisted_1 = { class: "programme" }
const _hoisted_2 = { class: "programme__content" }
const _hoisted_3 = { class: "programme__inner" }
const _hoisted_4 = { class: "programme__day" }
const _hoisted_5 = { class: "programme__timeline" }
const _hoisted_6 = { class: "programme__time" }
const _hoisted_7 = { class: "programme__detail" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "programme__day" }
const _hoisted_10 = { class: "programme__timeline" }
const _hoisted_11 = { class: "programme__time" }
const _hoisted_12 = { class: "programme__detail" }
const _hoisted_13 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("section", { class: "programme__hero" }, [
      _createElementVNode("div", { class: "programme__hero-overlay" }),
      _createElementVNode("div", { class: "programme__hero-content" }, [
        _createElementVNode("h1", null, "Programme")
      ])
    ], -1 /* CACHED */)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "programme__day-title" }, " Samedi 13 juin 2026 ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.samedi, (event) => {
              return _createElementVNode("div", {
                key: event.time,
                class: "programme__event"
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(event.time), 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "programme__dot" }, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h3", null, _toDisplayString(event.title), 1 /* TEXT */),
                  (event.desc)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(event.desc), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            }), 64 /* STABLE_FRAGMENT */))
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "programme__divider" }, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_9, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "programme__day-title" }, " Dimanche 14 juin 2026 ", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.dimanche, (event) => {
              return _createElementVNode("div", {
                key: event.time,
                class: "programme__event"
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(event.time), 1 /* TEXT */),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "programme__dot" }, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h3", null, _toDisplayString(event.title), 1 /* TEXT */),
                  (event.desc)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(event.desc), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            }), 64 /* STABLE_FRAGMENT */))
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "programme__divider" }, null, -1 /* CACHED */)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "footer__photo" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Elena & Antoine"
          })
        ], -1 /* CACHED */))
      ])
    ])
  ]))
}